export default "__VITE_ASSET__4042d93c__"